import { Component, OnInit,ViewChild } from '@angular/core';
import { AccountService } from './account.service';
import { AuthService } from '../services/auth.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
declare var jQuery:any;
@Component({
    selector: 'vpp-change-password',
    templateUrl: './change-password.component.html',
    providers: [AccountService]
})
export class ChangePasswordComponent implements OnInit {

    @ViewChild('passwordForm') passwordForm;
    OldPassword: string;
    NewPassword: string;
    ConfirmPassword: string;
    doiMkStatusMessage:string="";
    doiMkSuccess:boolean = false;
    class_css: string ="hidden";
    validatePass:boolean = true;
    checkNewPass:boolean = true;
    submited:boolean = false;
    loading: boolean = false;

    success: boolean = false;
    error: boolean = false;
    status: boolean = false;
    successMessage: string = "";
    errorMessage: string = "";
    statusMessage: string = "";    
    redirectUrl:string="https://tructichhop.daklak.gov.vn/group/lgsp/doi-mat-khau";
    constructor(
     private router: Router,
     private accountService:AccountService,
     public auth:AuthService,) { }
    ngOnInit() {  
        var idtokenxt = localStorage.getItem('scnnttidtoken');
        if (this.redirectUrl && idtokenxt) {
            window.location.href = this.redirectUrl;            
        }

        this.doiMkStatusMessage = "";
        this.class_css = "hidden";
        this.ReSetForm();        
    }
    ReSetForm(){
        this.loading = false;
        this.OldPassword = "";
        this.NewPassword = "";
        this.ConfirmPassword = "";

    }
    ShowAlert(message: string, option: string, pop: boolean = false)
    {
        if(pop) {
            
        }
        else {            
            if (option == "success") {
                this.successMessage = message;
                this.success = true;                
                setTimeout(() => this.success = false, 3000);
            }
            else if (option == "error") {
                this.errorMessage = message;
                this.error = true;                
                setTimeout(() => this.error = false, 3000);
            }
            else {
                this.statusMessage = message;
                this.status = true;
            }
        }
    }
    HideAlert(option: string, pop: boolean = false)
    {
        if(pop) {
            
        }
        else {
            if (option == "success")
                this.success = false;
            else if (option == "error")
                this.error = false;
            else
                setTimeout(() => this.status = false, 1000);            
        }        
    }
    doimatkhau(){

        if(this.OldPassword.length >0){
            this.validatePass = true;
        }else{
            this.validatePass = false;
        }
        if(this.NewPassword.length >0 && this.ConfirmPassword.length>0 && this.NewPassword== this.ConfirmPassword){

            this.checkNewPass = true;
        }else{
            this.checkNewPass = false;
        }
           
        if(this.passwordForm.valid&& this.validatePass&&this.checkNewPass){
            var dto = {
                OldPassword: this.OldPassword,
                NewPassword: this.NewPassword,
                ConfirmPassword: this.ConfirmPassword
            };
            //this.ShowAlert("Đang lưu...", "status");            
            this.loading = true;
            this.accountService.changePassword(dto)
                .subscribe(
                    resp => {
                        this.HideAlert("status");          
                        console.log(resp);
                        if (resp.Success){                            
                            this.ShowAlert(resp.Message, "success");
                            
                        }
                        else {
                            this.ShowAlert(resp.Message, "error");
                        }
                        this.ReSetForm();
                    },
                    er => {
                        console.log(er);
                        this.doiMkStatusMessage = "Lỗi đổi mật khẩu";
                        this.ShowAlert(this.doiMkStatusMessage, "error");
                        this.ReSetForm();
                    }
                );
        }
        
    }
}


// WEBPACK FOOTER //
// D:/1.eGovD/CITIZEN/sources/citizen-admin/Angular/src/app/account/change-password.component.ts